import { HttpClient } from '@adapters/HttpClient';
import {
    ForgotPasswordRequest,
    LoginRequest,
    ResetPasswordRequest,
    User
} from '../models/Auth';

export class AuthApiAdapter {
    constructor(private httpClient: HttpClient) { }

    // 🎯 Autenticación
    async login(credentials: LoginRequest): Promise<{ token: { token: string; type?: string; expires_at?: string } }> {
        const response = await this.httpClient.post<{
            token: { token: string; type?: string; expires_at?: string };
        }>('/login', {
            email: credentials.email,
            password: credentials.password
        });

        return {
            token: {
                token: response.token.token,
                type: response.token.type || 'Bearer',
                expires_at: response.token.expires_at
            }
        };
    }

    async logout(): Promise<void> {
        await this.httpClient.post('/logout', {});
    }

    // 🎯 Perfil de usuario
    async getCurrentUser(): Promise<User> {
        const response = await this.httpClient.get<User>('/me', undefined, undefined, false);
        return response;
    }

    // 🎯 Solicitar reset de contraseña
    async requireResetPassword(request: ForgotPasswordRequest): Promise<void> {
        await this.httpClient.post('/password/require-reset', {
            email: request.email
        });
    }

    // 🎯 Confirmar reset de contraseña
    async confirmResetPassword(request: ResetPasswordRequest): Promise<void> {
        await this.httpClient.post('/password/confirm-reset', {
            email: request.email,
            password: request.password,
            token: request.token
        });
    }

    // 🎯 Cambiar de team
    async switchTeam(teamId: number): Promise<{
        token: string;
        current_team_id: number;
        current_role_id: number;
        expires_at?: string;
    }> {
        const response = await this.httpClient.post<{
            token: string;
            current_team_id: number;
            current_role_id: number;
            expires_at?: string;
        }>(`/me/team/${teamId}/switch`, {});

        // El endpoint puede devolver los datos en la raíz o dentro de data
        const payload: any = (response as any)?.data ?? response;

        return {
            token: payload.token,
            current_team_id: payload.current_team_id,
            current_role_id: payload.current_role_id,
            expires_at: payload.expires_at,
        };
    }
} 
